import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function useCommentsQuery(type, id, options) {
  return useQuery(QUERY_CACHE_KEY.comments(type, id), options);
}

export default useCommentsQuery;
